// extracted by mini-css-extract-plugin
export var quantityInput = "_np-0";